import { Card, CardBody, Col } from "reactstrap";
import {  WarningBorderState } from "../../../../Constant";
import { BORDER_WARNING } from "../../../../Data/Bonus Ui/CreativeCard";
import CommonCreativeCardHeader from "../Common/CommonCreativeCardHeader";
import { LI, OL } from "../../../../AbstractElements";

const BorderWarningState = () => {
  return (
    <Col xxl="4" md="6">
      <Card className="height-equal">
        <CommonCreativeCardHeader headerClass="border-l-warning border-3" title={WarningBorderState} span={BORDER_WARNING} />
        <CardBody className="mb-3">
          <OL className="list-group list-group-numbered">
            <LI className="txt-primary fw-bold" >known for delivery of useful and usable solutions</LI>
            <LI className="txt-danger fw-bold" >Solve your problem with us</LI>
            <LI className="txt-success fw-bold" >Certified Professionals</LI>
            <LI className="txt-warning fw-bold" >Growth-Driven</LI>
          </OL>
        </CardBody>
      </Card>
    </Col>
  )
}

export default BorderWarningState